import { createAsyncThunk } from "@reduxjs/toolkit";
import * as jobCreatorService from "../../services/jobCreatorService";
import { enqueueSnackbar } from "notistack";
import * as API from "../../services/Api";

// Helper function to set auth token
const setAuthToken = (getState) => {
  const state = getState();
  const token =
    state.auth?.user?.authentication?.accessToken ||
    localStorage.getItem("token");

  if (token) {
    API.setHeaderAuthorization(token);
  }
};

export const getJobsByCreatorStatus = createAsyncThunk(
  "jobCreator/getJobsByCreatorStatus",
  async (params, { getState, rejectWithValue }) => {
    try {
      // Set auth token
      setAuthToken(getState);

      let {
        status,
        page = 1,
        limit = 10,
        search,
        compensation,
        categoryIds,
        languageIds,
      } = params;

      // Construct query parameters
      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      queryParams.append("limit", limit);

      if (search) queryParams.append("search", search);
      if (compensation) queryParams.append("compensation", compensation);
      if (categoryIds) queryParams.append("categoryIds", categoryIds);
      if (languageIds) queryParams.append("languageIds", languageIds);

      // Make API call with constructed query string
      const response = await API.get(
        `job-creator/${status}?${queryParams.toString()}`
      );
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const getCreatorJobById = createAsyncThunk(
  "jobCreator/getCreatorJobById",
  async (id, { getState, rejectWithValue }) => {
    try {
      // Set auth token
      setAuthToken(getState);

      const response = await jobCreatorService.getCreatorJobById(id);
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const applyJob = createAsyncThunk(
  "jobCreator/applyJob",
  async (jobData, { getState, rejectWithValue }) => {
    try {
      // Set auth token
      setAuthToken(getState);

      const response = await jobCreatorService.applyJob(jobData);
      enqueueSnackbar(
        response.message || "Job application submitted successfully",
        {
          variant: "success",
        }
      );

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const creatorJobAction = createAsyncThunk(
  "jobCreator/creatorJobAction",
  async ({ id, data }, { getState, rejectWithValue }) => {
    try {
      // Set auth token
      setAuthToken(getState);

      const response = await jobCreatorService.creatorJobAction(id, data);

      enqueueSnackbar(response.message, {
        variant: "success",
      });

      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);
